import useMatch from './useMatch';
export default function useLocation() {
  var _useMatch;
  return (_useMatch = useMatch()) == null ? void 0 : _useMatch.location;
}